module.exports = __webpack_public_path__ + "static/media/FittcoachLogo.74c1a1bc.svg";